var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2B910665-D85B-4B1F-8949-E73F18F134D6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Promos-Table",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promotions",
    transform: "translate(-908.000000, -687.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(33.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-6",
    transform: "translate(3.000000, 168.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(854.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TablePart/Row/StatusColumn/Scheduled-Copy-21",
    transform: "translate(0.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Clock",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Settings"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "InProgress",
    transform: "translate(0.000000, 0.894737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6996927,14.8045883 C13.4502725,15.8484228 11.8777263,16.4235969 10.2405549,16.4235969 C6.42766886,16.4235969 3.3256599,13.3560016 3.3256599,9.58541581 L3.3256599,9.15936092 L4.31657943,9.15936092 C4.57508017,9.15936092 4.81203919,9.0102417 4.94128957,8.79721426 C5.07053994,8.56288406 5.04899821,8.28594838 4.91974784,8.07292093 L3.13178434,5.30356411 C2.87328359,4.89881196 2.18394827,4.89881196 1.92544752,5.30356411 L0.115942295,8.07292093 C-0.0348498069,8.28594838 -0.0348498069,8.56288406 0.0944005664,8.79721426 C0.22365094,9.0102417 0.460609957,9.15936092 0.719110704,9.15936092 L1.71003023,9.15936092 L1.71003023,9.58541581 C1.71003023,14.2294142 5.52291624,18 10.2190131,18 C12.2223939,18 14.1826913,17.2970094 15.712154,16.0188447 C16.0568217,15.7419091 16.0999051,15.2306432 15.7983209,14.911102 C15.5398202,14.5702581 15.0443604,14.5276526 14.6996927,14.8045883 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9131219,9.20655738 C19.7838104,8.97213115 19.5467393,8.8442623 19.2881163,8.8442623 L18.2967281,8.8442623 L18.2967281,8.41803279 C18.2967281,3.77213115 14.4820388,0 9.78372095,0 C7.77939268,0 5.81816823,0.703278689 4.28798213,1.98196721 C3.94315146,2.25901639 3.90004762,2.7704918 4.20177446,3.09016393 C4.48194938,3.43114754 4.99919539,3.47377049 5.32247414,3.17540984 C6.57248533,2.13114754 8.14577526,1.5557377 9.78372095,1.5557377 C13.5984103,1.5557377 16.7018863,4.62459016 16.7018863,8.39672131 L16.7018863,8.82295082 L15.7104981,8.82295082 C15.4518751,8.82295082 15.214804,8.97213115 15.0854925,9.1852459 C14.956181,9.41967213 14.9777329,9.69672131 15.1070444,9.90983607 L16.8958535,12.6803279 C17.025165,12.8934426 17.2622361,13 17.4993072,13 C17.7363783,13 17.9734494,12.8721311 18.1027609,12.6803279 L19.89157,9.90983607 C20.0208815,9.71803279 20.0424334,9.44098361 19.9131219,9.20655738 Z",
    id: "Path"
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveStatus);
export default __webpack_public_path__ + "static/media/LiveStatus.4836e1967200921353b76df3105c3ba8.svg";
export { ForwardRef as ReactComponent };